export const SITE_URL = 'https://aicarma.com';
export const BILLING_URL = 'https://billing.aicarma.com/p/login/fZe4jzbymclk98c288';
export const TERMS_URL = 'https://aicarma.com/terms-of-use/';
export const PRIVACY_URL = 'https://aicarma.com/privacy-policy/';
